"use client";

import Link from "next/link";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ButtonLink } from "@/components/ui/button-link";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/lib/store";

export default function SignupPage() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const router = useRouter();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    await new Promise((r) => setTimeout(r, 700));
    login("new@user.fr");
    router.push("/onboarding/company");
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-surface-secondary px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-2">
          <Link href="/" className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-600">
            <Shield className="h-5 w-5 text-white" />
          </Link>
          <h1 className="text-xl font-bold text-text-primary">Créer votre compte</h1>
          <p className="text-sm text-text-secondary">Sans engagement, résiliable à tout moment.</p>
        </div>

        <div className="rounded-xl border border-border bg-surface p-6 shadow-card">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-3">
              <Input label="Prénom" placeholder="Jean" required />
              <Input label="Nom" placeholder="Dupont" required />
            </div>
            <Input label="Adresse e-mail" type="email" placeholder="vous@entreprise.fr" required />
            <Input label="Téléphone" type="tel" placeholder="+33 6 00 00 00 00" />
            <Input
              label="Mot de passe"
              type="password"
              placeholder="••••••••"
              hint="8 caractères minimum"
              required
            />
            <Button type="submit" className="w-full mt-1" loading={loading}>
              Créer mon compte et continuer
            </Button>
            <p className="text-center text-xs text-text-muted">
              En créant un compte, vous acceptez nos{" "}
              <Link href="#" className="text-brand-600 hover:underline">CGU</Link>.
            </p>
          </form>
        </div>

        <p className="mt-5 text-center text-sm text-text-secondary">
          Déjà un compte ?{" "}
          <Link href="/login" className="font-medium text-brand-600 hover:underline">Se connecter</Link>
        </p>
      </div>
    </div>
  );
}
